import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../FontAwesomeIcons";
import moment from "moment";
import './VideoMessage.css';

export class VideoMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mediaUrl: null,
            shouldAutoplay: false,
            previewRatio: null,
            previewWidth: 300,
            previewSourceUrl: null,
        };
        this.videoRef = React.createRef();
    }

    componentDidMount() {
        this.updatePreviewDimensions();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.mediaUrl && this.state.mediaUrl !== prevState.mediaUrl && this.videoRef.current) {
            const video = this.videoRef.current;
            video.load();
            if (this.state.shouldAutoplay) {
                const playPromise = video.play();
                if (playPromise?.catch) playPromise.catch(() => {
                });
                this.setState({shouldAutoplay: false});
            }
        }

        const currentPreviewUrl = this.getAttachmentPreviewUrl();
        const prevPreviewUrl = this.getAttachmentPreviewUrl(prevProps.messageData);
        if (currentPreviewUrl !== prevPreviewUrl) this.updatePreviewDimensions();
    }

    handleLoadVideo = () => {
        if (this.state.mediaUrl) return;
        const mediaUrl = this.props.getMediaContentUrlAPI(this.props.messageData.id_messaggio);
        this.setState({mediaUrl, shouldAutoplay: true});
    }

    getAttachmentPreviewUrl = (messageData = this.props.messageData) => {
        const hasAttachmentPreview = !!(messageData?.metadata?.attachment_preview_url);
        if (!hasAttachmentPreview) return null;
        if (this.props.getMediaContentPreviewUrlAPI) return this.props.getMediaContentPreviewUrlAPI(messageData.id_messaggio);
        return messageData.metadata.attachment_preview_url;
    }

    updatePreviewDimensions = () => {
        const attachmentPreviewUrl = this.getAttachmentPreviewUrl();
        if (!attachmentPreviewUrl) {
            this.setState({previewRatio: null, previewWidth: 300, previewSourceUrl: null});
            return;
        }

        if (this.state.previewSourceUrl === attachmentPreviewUrl) return;

        const image = new Image();
        image.onload = () => {
            const width = image.naturalWidth || 0;
            const height = image.naturalHeight || 0;
            if (!width || !height) {
                this.setState({previewRatio: null, previewWidth: 300, previewSourceUrl: attachmentPreviewUrl});
                return;
            }

            const previewRatio = height / width;
            const maxVideoWidth = 300;
            const previewWidth = 300;//previewRatio > 1 ? Math.max(120, Math.round(maxVideoWidth / previewRatio)) : maxVideoWidth;
            this.setState({previewRatio, previewWidth, previewSourceUrl: attachmentPreviewUrl});
        };

        image.onerror = () => this.setState({
            previewRatio: null,
            previewWidth: 300,
            previewSourceUrl: attachmentPreviewUrl
        });
        image.src = attachmentPreviewUrl;
    }

    render() {
        const {isMine, messageData} = this.props;
        const {mediaUrl, previewRatio, previewWidth} = this.state;
        const sendTime = moment(messageData.data_creazione).format('HH:mm');
        const attachmentPreviewUrl = this.getAttachmentPreviewUrl();
        const previewPaddingTop = previewRatio ? `${previewRatio * 100}%` : '56.25%';

        const videoStyle = {
            width: previewWidth,
            maxWidth: 300,
            borderRadius: 15
        };

        const placeholderStyle = {
            ...videoStyle,
            backgroundColor: '#f0f0f0',
            position: 'relative',
            overflow: 'hidden',
            border: '1px solid rgba(0,0,0,0.1)',
            boxShadow: 'inset 0 0 20px rgba(0,0,0,0.08)'
        };

        const overlayStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease-in-out'
        };

        const placeholderInnerStyle = attachmentPreviewUrl ? {
            backgroundImage: `url("${attachmentPreviewUrl}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            paddingTop: previewPaddingTop,
            minWidth: previewWidth
        } : {
            paddingTop: previewPaddingTop,
            minWidth: previewWidth
        };

        const videoPlayerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: 15,
            backgroundColor: '#000'
        };

        return (
            <React.Fragment>
                <div className={"mb-2 video-placeholder"} style={placeholderStyle}>
                    <div className={"video-placeholder-inner"} style={placeholderInnerStyle}>
                        {
                            mediaUrl &&
                            <video
                                ref={this.videoRef}
                                controls={true}
                                style={videoPlayerStyle}
                                preload={"none"}
                                poster={attachmentPreviewUrl || undefined}
                            >
                                <source src={mediaUrl} type={messageData.metadata.mime_type}/>
                                Your browser does not support the video element.
                            </video>
                        }
                        {
                            !mediaUrl &&
                            <div
                                style={overlayStyle}
                                className={"video-placeholder-overlay"}
                                onClick={this.handleLoadVideo}
                            >
                                <span className={"video-placeholder-button"}>
                                    <FaSolidIcon name={"play"}/>
                                </span>
                            </div>
                        }
                    </div>

                </div>
                <div className={"metadata"}>
                    {sendTime}&nbsp;
                    {
                        isMine &&
                        <FaSolidIcon name={messageData.letto === '1' ? 'check-double' : 'check'}/>
                    }
                </div>
            </React.Fragment>
        );
    }
}

VideoMessage.propTypes = {
    isMine: PropTypes.bool,
    messageData: PropTypes.object.isRequired,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
    getMediaContentPreviewUrlAPI: PropTypes.func,
};
